"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTranslation = exports.translate = void 0;
const react_1 = __importDefault(require("react"));
const lodash_get_1 = __importDefault(require("lodash.get"));
const languages_1 = require("./languages");
exports.default = {
    en: languages_1.en,
};
const dictionary = languages_1.en;
const translate = (accessor, values) => {
    let localeValue = lodash_get_1.default(dictionary, accessor) || lodash_get_1.default(dictionary, `deprecated.${accessor}`);
    // Allow deeper customisation by giving user option to pass functions into locale, which receive accessor and values
    if (typeof localeValue === "function") {
        localeValue = localeValue(accessor, values);
    }
    // Unable to match translation so just return accessor string
    if (!localeValue) {
        return accessor;
    }
    // Split our input string into an array including replacements eg:
    // 'Page {{page}} of {{pages}} ({{start}}-{{end}} of {{items}} items)' becomes
    // ['Page ', '{{page}}', 'of ', '{{pages}}', ' (', '{{start}}', '-', '{{end}}', ' of ', '{{items}}', 'items', ')']
    const split = localeValue.split(/(\{\{.*?}})/g);
    // Swap out our value keys so we wrap them in our template language: key of `path` becomes `{{path}}`
    // { page: '1' } -> { '{{page}}': '1' }
    const newValues = Object.assign({}, ...(Object.entries(values || {}) || []).map(([key, value]) => ({
        [`{{${key}}}`]: value,
    })));
    // Lookup values from our split string, using our new matching keys created in newValues
    // If nothing is found (undefined), return the lookup value
    const swapped = split.map((lookup) => { var _a; return (_a = lodash_get_1.default(newValues, lookup)) !== null && _a !== void 0 ? _a : lookup; });
    // Uncomment to expand functionality to react nodes
    if (Object.values(newValues).filter((value) => react_1.default.isValidElement(value)).length) {
        // One of our values is a react component, so we need to return JSX as part of the array
        return swapped;
    }
    // Otherwise return a single string
    return swapped.join("");
};
exports.translate = translate;
const useTranslation = () => {
    return { translate: exports.translate, locale: dictionary };
};
exports.useTranslation = useTranslation;
